import { defineComponent as _defineComponent } from 'vue'
import { SnowplowContext } from '@/helpers/tracking/providers';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitlePosterRibbonGraphqlLite',
  props: {
    position: { default: 'left' },
    additionalContexts: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { position: 'left' | 'right', additionalContexts: SnowplowContext[] };



const onRibbonClick = async () => {
	const { preventNonSignedInAction } = await import('@/helpers/prevent-non-signed-in-action-helper');
	// since we only display `<TitlePosterRibbonGraphqlLite>` to logged-out users,
	// the next function should always return true and open the `ListsForSignedInUsersModal` modal.

	preventNonSignedInAction(undefined, props.additionalContexts);
};

return { __sfc: true,props, onRibbonClick, faBookmark }
}

})